import axios from 'axios'
import { getToken, signDo, removeToken, getSession, removeSession } from '@/utils'
import router from '../router'
import store from '@/store'
import { theme } from '@/utils/theme'
import { isMobile, isIOS } from '@/utils/validate'
import qs from 'qs'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_URL, // api 的 base_url
  timeout: 30000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 格式化数据
    config.baseURL = `//${theme[store.getters.init.ui_type].apiName}.com/api/h5/index.php`
    const mobileInfo = window.mobileInfo
    const appid = store.getters.appid
    const imei = store.getters.idfa
    const agentId = router.history.current.query.agent_id || 100000
    const siteId = router.history.current.query.site_id || 100000
    const os = mobileInfo.os
    const model = mobileInfo.model
    const systemversion = mobileInfo.version
    const idfan = router.history.current.query.idfan || ''
    const mtype = router.history.current.query.mtype || 1
    // 处理post和get请求字段名不一样的情况
    if (config.method === 'post') {
      [config.headers['Sign'], config.headers['Timestamp']] = signDo(config.data.do)
      config.data = Object.assign({}, config.data, { appid, imei, agent_id: agentId, site_id: siteId, os, model, systemversion, idfan, mtype })
      if (isMobile()) {
        config.data = Object.assign({}, config.data, { os, model, systemversion })
      }
      if (isIOS()) {
        config.data.idfaiv = router.history.current.query.idfv || ''
      }
      // session_id字段名换成phpsessid
      if (getSession() && getSession() !== 'undefined') config.data.phpsessid = store.getters.sessionId
    }
    if (config.method === 'get') {
      [config.headers['Sign'], config.headers['Timestamp']] = signDo(config.params.do)
      config.params = Object.assign({}, config.params, { appid, imei, agent_id: agentId, site_id: siteId, os, model, systemversion, idfan, mtype })
      if (isMobile()) {
        config.params = Object.assign({}, config.params, { os, model, systemversion })
      }
      if (isIOS()) {
        config.params.idfaiv = router.history.current.query.idfv || ''
      }
      // session_id字段名换成phpsessid
      if (getSession() && getSession() !== 'undefined') config.params.phpsessid = store.getters.sessionId
    }
    config.data = qs.stringify(config.data)
    if (getToken() && getToken() !== 'undefined') {
      config.headers['Authorization'] = getToken()
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    if (response.data.error_code === 1006) {
      removeToken()
      removeSession()
      store.commit('SET_TOKEN', '')
      store.commit('SET_SESSION_ID', '')
      window.location.reload()
      return Promise.reject(response.data)
    } else {
      return response
    }
  }
)

export default service
